// export const solCurrency= [
//     { value: "0", key: "SOL",type:'1',decimal:9,priceCoin:"SOL"  },
//     { value: "1", key: "USDT (SOL)" ,type:'2',char:"SO",decimal:6, priceCoin:"USDT",mintAddress:"7Puto9h7EDkMnzQNK9cW7TbgVGQgsF2p8Bv436KuqkZk"},
//     { value: "2", key: "USDC (SOL)" ,type:'1',char:"SO",decimal:6, priceCoin:"USDC",mintAddress:"FGonSijLUgnck2Pak3vSbqKjhg5nPSoVycM44wUvdQ4e"},
//   ]

import { ethCurrency } from "./eth";

export const chainTypeEnum = [
  {
    key: "SOL",
    value: "0",
    custom: 0,
    image: "/assets/img/solana.png",
  },
  {
    key: "Eth",
    value: "1",
    custom: 0,
    image: "/assets/img/eth.png",
  },
];
export const solChainEnum = "0";
export const solImage = "/assets/img/solana.png";

const solCurrency = [
  { value: "0", key: "SOL", type: "1", decimal: 9, priceCoin: "SOL" },
  {
    value: "1",
    key: "USDT (SOL)",
    type: "2",
    char: "SO",
    decimal: 6,
    priceCoin: "USDT",
    mintAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
  },
  {
    value: "2",
    key: "USDC (SOL)",
    type: "1",
    char: "SO",
    decimal: 6,
    priceCoin: "USDC",
    mintAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  },
];

export const currencyTypeEnum = {
  0: solCurrency,
  1: ethCurrency,
};

export const coinTypeEnum = "1";
export const tokenTypeEnum = "2";
export const getLivePriceURL =
  "https://api.binance.com/api/v3/ticker/price?symbol=";
export const minUsdtBuy = 1;
export const maxUsdtBuy = 6000000000000;

export const bonusEnum = [
  {
    minValue: 0,
    maxValue: 1999,
    bonusPer: 10,
  },
  {
    minValue: 2000,
    maxValue: 3499,
    bonusPer: 15,
  },
  {
    minValue: 3500,
    maxValue: 6000000000000,
    bonusPer: 20,
  },
];

